package twist.mena.sports.admin.components

import androidx.compose.runtime.*
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import twist.mena.sports.admin.theme.*

@Composable
fun SearchBar(
    placeholderText: String = "Search...",
    onSearch: (String) -> Unit
) {
    val colors = AppTheme.colors
    var text by remember { mutableStateOf("") }
    val scope = rememberCoroutineScope()

    Div({
        style { marginBottom(Spacing.lg) }
    }) {
        Input(type = org.jetbrains.compose.web.attributes.InputType.Text) {
            value(text)
            placeholder(placeholderText)
            onInput { event ->
                text = event.value
                scope.launch {
                    delay(300)
                    if (text == event.value) {
                        onSearch(text)
                    }
                }
            }
            style {
                width(300.px)
                formInputStyle(colors)
            }
        }
    }
}
